import { PlaceholderModel } from 'api/dto/Placeholder.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'placeholders';

export namespace PlaceholdersState {
  export type Domain = {
    listResource: Resource<PlaceholderModel[]>;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource<PlaceholderModel[]>(),
  };
}
